module.exports = __webpack_public_path__ + "img/258.operational.78756c95.svg";